import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, MARKETMULTITOKEN } from '../constants/bakery/nft'

export function userNftTypeNum(type?: string) {
  let nftType = 1
  switch (type) {
    case MARKETTYPE.BTCARTWORK:
    case MARKETTYPEV1.BTCARTWORKV1:
    case MARKETTYPEV3.BTCARTWORKV3:
      nftType = 1
      break
    case MARKETTYPE.BAKERYARTWORK:
    case MARKETTYPEV1.BAKERYARTWORKV1:
    case MARKETTYPEV3.BAKERYARTWORKV3:
      nftType = 3
      break
    case MARKETTYPE.MUSKDOGE:
    case MARKETTYPEV1.MUSKDOGEV1:
    case MARKETTYPEV3.MUSKDOGEV3:
      nftType = 4
      break
    case MARKETTYPE.MEME:
    case MARKETTYPEV1.MEMEV1:
    case MARKETTYPEV3.MEMEV3:
      nftType = 5
      break
    case MARKETTYPE.SEASCAPE:
    case MARKETTYPEV1.SEASCAPEV1:
    case MARKETTYPEV3.SEASCAPEV3:
      nftType = 6
      break
    case MARKETTYPE.TKONFT:
    case MARKETTYPEV1.TKONFTV1:
    case MARKETTYPEV3.TKONFTV3:
      nftType = 7
      break
    case MARKETTYPE.ONEINCH:
    case MARKETTYPEV1.ONEINCHV1:
    case MARKETTYPEV3.ONEINCHV3:
      nftType = 8
      break
    case MARKETTYPE.BAKERYSOCCER:
    case MARKETTYPEV1.BAKERYSOCCERV1:
    case MARKETTYPEV3.BAKERYSOCCERV3:
      nftType = 100
      break
    case MARKETTYPE.SFPARTWORK:
    case MARKETTYPEV1.SFPARTWORKV1:
    case MARKETTYPEV3.SFPARTWORKV3:
      nftType = 101
      break
    case MARKETTYPE.LOVE:
    case MARKETTYPEV1.LOVEV1:
    case MARKETTYPEV3.LOVEV3:
      nftType = 105
      break
    case MARKETMULTITOKEN.POKERMULTITOKEN:
    case MARKETTYPEV3.POKERCARDV3:
      nftType = 106
      break
    case MARKETTYPE.BARKNFT:
    case MARKETTYPEV3.BARKNFTV3:
      nftType = 108
      break
    case MARKETTYPE.YOOSHINFT:
    case MARKETTYPEV1.YOOSHINFTV1:
    case MARKETTYPEV3.YOOSHINFTV3:
      nftType = 109
      break
    case MARKETTYPE.RACANFT:
    case MARKETTYPEV1.RACANFTV1:
    case MARKETTYPEV3.RACANFTV3:
    case MARKETMULTITOKEN.RACAMULTITOKEN:
      nftType = 107
      break
    case MARKETTYPE.BONDLYNFT:
    case MARKETTYPEV1.BONDLYNFTV1:
    case MARKETTYPEV3.BONDLYNFTV3:
      nftType = 110
      break
    case MARKETTYPE.BAKERYBSCARTWORK:
    case MARKETTYPEV1.BAKERYBSCARTWORKV1:
    case MARKETTYPEV3.BAKERYBSCARTWORKV3:
      nftType = 111
      break
    case MARKETMULTITOKEN.TOKAUMULTITOKEN:
    case MARKETTYPEV3.TOKAUV3:
      nftType = 112
      break
    case MARKETMULTITOKEN.MATRIXMULTITOKEN:
    case MARKETTYPEV3.MATRIXV3:
      nftType = 113
      break
    case MARKETMULTITOKEN.TOYMULTITOKEN:
    case MARKETTYPEV3.TOYV3:
      nftType = 115
      break
    case MARKETMULTITOKEN.KAKAMULTITOKEN:
    case MARKETTYPEV3.KAKAV3:
      nftType = 116
      break
    case MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN:
    case MARKETTYPEV3.BAKEMUSKV3:
      nftType = 117
      break
    case MARKETTYPEV3.BLINV3:
      nftType = 119
      break
    case MARKETTYPEV3.BINAMONV3:
      nftType = 121
      break
    case MARKETTYPEV3.GAV3:
      nftType = 120
      break
    case MARKETTYPEV3.KTAV3:
      nftType = 122
      break
    case MARKETTYPEV3.KRBV3:
      nftType = 123
      break
    case MARKETTYPEV3.KRIPTOMONV3:
      nftType = 124
      break
  }
  return nftType
}

